<template>
  <iProgressBar
    :value="percent"
    :height="barHeight"
    :border-radius="barHeight"
    :fill-color="barFill"
    :track-color="barTrack"
    width="100%"
    data-test="step-progress-bar"
  />
</template>

<script>
import App from "@bloglovin/inspire-engine/App";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import { resolveBoundEntityId } from "%/dynamic-component-editor/helpers/bound-context-entity-id";
import { declaredAppOption, declaredAppOptions } from "%/dynamic-component-editor/options/declared-app-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import { QUIZZES_POLLS_APP_NAME } from "+/QuizzesPolls/app-name";

const SUBMISSION_CONTEXT_NAME = "submission";
const SUBMISSION_ENTITY_TYPE = "Submission";
const STEP_PERCENT_FIELD = "stepPercent";
const PREVIEW_PERCENT = 40;
const BAR_THICKNESS_KEY = "step-bar-thickness";
const BAR_FILL_KEY = "step-bar-fill";
const BAR_TRACK_KEY = "step-bar-track";

export default {
  name: "StepProgressElement",
  mixins: [DynamicElementMixin],
  inject: {
    pageEntities: { default: null },
    scopedProvidedContexts: { default: null },
  },
  elementPanelSettings: {
    displayName: "Step Progress Bar",
    displayIcon: "mdi:progress-helper",
    elementType: "element",
    elementGroup: "general",
  },
  options: [
    ...declaredAppOptions(QUIZZES_POLLS_APP_NAME, [BAR_THICKNESS_KEY, BAR_FILL_KEY, BAR_TRACK_KEY]),
  ],
  optionBundles: [new AppearanceOptions()],
  computed: {
    barHeight() {
      return this.declaredValue(BAR_THICKNESS_KEY);
    },
    barFill() {
      return this.declaredValue(BAR_FILL_KEY);
    },
    barTrack() {
      return this.declaredValue(BAR_TRACK_KEY);
    },
    questionnaireApp() {
      try {
        return App.get(QUIZZES_POLLS_APP_NAME);
      } catch {
        return null;
      }
    },
    submissionEntityId() {
      return resolveBoundEntityId(this, SUBMISSION_CONTEXT_NAME) || 0;
    },
    percent() {
      if (this.editMode || !this.submissionEntityId || !this.questionnaireApp) {
        return PREVIEW_PERCENT;
      }
      try {
        return Number(this.questionnaireApp.getEntityField(
          SUBMISSION_ENTITY_TYPE,
          { id: this.submissionEntityId },
          STEP_PERCENT_FIELD,
        )) || 0;
      } catch {
        return 0;
      }
    },
  },
  methods: {
    declaredValue(optionKey) {
      const optionClass = declaredAppOption(QUIZZES_POLLS_APP_NAME, optionKey);
      return optionClass ? this.getOptionValue(optionClass) : "";
    },
  },
};
</script>
